import { useId } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';

import { Wrapper } from '@american-autonomy/ag-ui';

import DateInput from 'components/inputs/DateInput';

import useSingleDatePicker from './hooks/useSingleDatePicker';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SingleDatePicker: FunctionComponent<Props> = ({
    className = '',
    maxDate,
    onChange,
    testId = TEST_ID,
    value
}) => {
    const inputId = useId();
    const { DATE_PLACEHOLDER } = useTranslation();

    const {
        containerRef,
        effectiveMaxDate,
        handleBlur,
        handleOpen,
        handleSelect,
        handleTextChange,
        inputRef,
        inputValue,
        popoverRef,
        selectedDate
    } = useSingleDatePicker({ maxDate, onChange, value });

    return (
        <Wrapper className={`${className} ${styles.singleDatePicker}`} testId={testId}>
            <Wrapper className={styles.inputsContainer} ref={containerRef}>
                <DateInput
                    id={inputId}
                    onBlur={handleBlur}
                    onChange={handleTextChange}
                    onClick={handleOpen}
                    placeholder={DATE_PLACEHOLDER}
                    ref={inputRef}
                    testId={`${testId}-input`}
                    value={inputValue ?? ''}
                />
            </Wrapper>

            <div
                className={styles.dropdown}
                data-testid={`${testId}-dropdown`}
                popover='manual'
                ref={popoverRef}>
                <DayPicker
                    defaultMonth={selectedDate ?? effectiveMaxDate}
                    disabled={{ after: effectiveMaxDate }}
                    mode='single'
                    onSelect={handleSelect}
                    selected={selectedDate}
                    toMonth={effectiveMaxDate}
                />
            </div>
        </Wrapper>
    );
};

export default SingleDatePicker;
